import { NetworkOps } from "./NetworkOps.js";
import { getAPIURL } from "./networkUtils.js";

const apiURL = getAPIURL();
export const rootAPI = new NetworkOps({
  baseURL: `${apiURL}`
});

export const createIssue = (consumerId, payload) => {
  return rootAPI.post(`/support/${consumerId}/issue`, payload);
};

export const attachment = (id, consumerId, payload) => {
  return rootAPI.post(`/support/attachment/${consumerId}/${id}`, payload);
};

export const fetchData = (consumerId) => {
  return rootAPI.get(`/support/search/${consumerId}/issues`);
};
